import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import axios from "axios";
import ReactModal from 'react-modal';

import authHeader from "../../services/auth-header";
import Table from '../Table';
import { TextControl, SelectControl } from './Controls';
import DetailsDriverModal from "./modals/DetailsDriverModal";

ReactModal.setAppElement('#root');

function Drivers() {

    const { user: currentUser } = useSelector((state) => state.auth);

    const [drivers, setDrivers] = useState([]);
    const [currentDriver, setCurrentDriver] = useState([]);

    const [statusFilter, setStatusFilter] = useState(1);

    const [tablePage, setTablePage] = useState(0);
    const [tableSearchValue, setTableSearchValue] = useState('');
    const [tableSearchFields, setTableSearchFields] = useState(['fullName', 'driverNumber', 'cab']);

    const [isEditModalOpened, openEditModal] = useState(false);

    function isUserAllowed() {
        if (currentUser) {
            if (!currentUser.roles.includes("ROLE_MANAGER"))
                return <Redirect to="/login" />;
        }
        else
            return <Redirect to="/login" />;
    }
    isUserAllowed();

    useEffect(() => {
        getDrivers();
    }, [statusFilter]);

    useEffect(() => {
        setTablePage(0);
    }, [tableSearchValue, tableSearchFields]);

    async function getDrivers() {
        let result = await axios.get(process.env.REACT_APP_API_URL + `api/admin/viewDrivers/${statusFilter}`, { headers: authHeader() })
        if (result)
            setDrivers(result.data);
    }

    async function handleStatusChange(driver, statusId) {
        statusId = (!statusId) ? 2 : 1;
        try {
            await axios.put(process.env.REACT_APP_API_URL + `api/admin/toggleMember/${driver.memberId}`, {
                statusId
            }, {
                headers: authHeader()
            });
            getDrivers();
        } catch (error) {
            getDrivers();
        }
    }

    function getDriverRow(driver) {
        return (
            <tr key={driver.driverId}>
                <td className="center-align">
                    <div className={driver.type == 'D' ? 'green lighten-3' : 'blue lighten-3'} style={{ borderRadius: '5px' }}>
                        {driver.type}
                    </div>
                </td>
                <td className="center-align">{driver.driverNumber ? driver.driverNumber : 'None'}</td>
                <td className="center-align">{driver.fullName}</td>
                <td className="center-align">{driver.cab ? driver.cab : 'Not assigned'}</td>
                <td className="center-align">
                    <div className="switch">
                        <label>
                            Inactive
                            <input type="checkbox" checked={driver.statusId == 1 ? true : false} onChange={(event) => handleStatusChange(driver, event.target.checked)} />
                            <span className="lever"></span>
                            Active
                        </label>
                    </div>
                </td>
                <td className="center-align">
                    <a onClick={() => {
                        setCurrentDriver(driver);
                        openEditModal(true);
                    }} href="#modal-edit" className="btn-floating waves-effect waves-light black white-text">
                        <i className="material-icons">create</i>
                    </a>
                </td>
            </tr>
        );
    }

    return (
        <div className="container">
            <div className="row valign-wrapper">
                <div className="hide-on-small-only col m12" style={{ fontVariant: 'small-caps', fontFamily: 'Raleway', fontSize: '3rem' }}>
                    Drivers
                </div>
            </div>
            <hr />
            <div className="row" style={{ padding: '20px 0px' }}>
                <div className="input-field col s8">
                    <TextControl id="tableSearchValue" value={tableSearchValue} inputEventHandler={setTableSearchValue} focusEventHandler={() => null} />
                    <label htmlFor="tableSearchValue">Search</label>
                </div>
                <div className="input-field col s4">
                    <SelectControl value={statusFilter} inputEventHandler={setStatusFilter} focusEventHandler={() => null}>
                        <option value="1" selected>Active</option>
                        <option value="2">Inactive</option>
                    </SelectControl>
                </div>
            </div>
            <div className="row z-depth-1 white" style={{ padding: '10px', margin: '20px 0px' }}>
                <Table
                    style={{ tableLayout: 'auto' }}
                    tableHead={
                        <thead>
                            <tr className="center-align">
                                <th className="center-align">Type</th>
                                <th className="center-align">Id #</th>
                                <th className="center-align">Name</th>
                                <th className="center-align">Cab #</th>
                                <th className="center-align">Status</th>
                                <th className="center-align">Details</th>
                            </tr>
                        </thead>
                    }
                    tableBody={
                        (rows) => <tbody>{rows}</tbody>}
                    tableFoot={null}
                    row={getDriverRow}
                    data={drivers}
                    searchValue={tableSearchValue}
                    searchFields={tableSearchFields}
                    show={10}
                    page={tablePage}
                    pagination={(pageRowAmount) => {
                        return (
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col s12 left">
                                    <a onClick={() => setTablePage(tablePage - 1)} disabled={!tablePage} className="waves-effect waves-black btn-flat">Previous</a>
                                    {(tablePage > 1 &&
                                        <>
                                            <a onClick={() => setTablePage(0)} className="waves-effect waves-black btn-flat">1</a>
                                            <span> ... </span>
                                        </>)}
                                    {(tablePage > 0 &&
                                        <a onClick={() => setTablePage(tablePage - 1)} className="waves-effect waves-black btn-flat">{tablePage}</a>)}
                                    <a disabled={true} className="waves-effect waves-black btn-flat">{tablePage + 1}</a>
                                    {(tablePage + 1 < pageRowAmount &&
                                        <a onClick={() => setTablePage(tablePage + 1)} className="waves-effect waves-black btn-flat">{tablePage + 2}</a>)}
                                    {(tablePage + 2 < pageRowAmount &&
                                        <>
                                            <span> ... </span>
                                            <a onClick={() => setTablePage(pageRowAmount - 1)} className="waves-effect waves-black btn-flat">{pageRowAmount}</a>
                                        </>)}
                                    <a onClick={() => setTablePage(tablePage + 1)} disabled={!(tablePage + 1 < pageRowAmount)} className="waves-effect waves-black btn-flat">Next</a>
                                </div>
                            </div>
                        );
                    }}
                />
            </div>

            <DetailsDriverModal isOpen={isEditModalOpened} onClose={() => openEditModal(false)} updateTable={getDrivers} currentDriver={currentDriver} />
        </div>
    );
}
export default Drivers;